/* -------------------------------------
 Validation Service
 - Custom validator rules used in forms.
-------------------------------------- */

export class ValidationService {
    
    //String must match regex = email address format
    static emailValidator(control) {
        if(control.value) {
            if (control.value.match(/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*\s*/)) {
                return null;
            } else {
                return { 'invalidEmailAddress': true };
            }
        }
    }

    //String must match regex for tel. number = must be numbers
    static phoneValidator(control) {
        if(control.value) {
            if (control.value.match(/^[0-9()\s-+]+$/)) {
                return null;
            } else {
                return { 'invalidTelephone': true };
            }
        }
    }

    //String must match regex for password = between 6 and 15 characters and include a number
    static passwordValidator(control) {
        if(control.value) {
            if (control.value.match(/(?!^[0-9]*$)(?!^[a-zA-Z]*$)^([a-zA-Z0-9]{6,15})$/)) {
                return null;
            } else {
                return { 'invalidPassword': true };
            }
        }
    }

    //Date must be after today
     static expiryDateValidator(control) {
        if(control.value) {
           if ( new Date(control.value) > new Date(new Date().toDateString()) ) {
                return null;
            } else {
                return { 'invalidExpiryDate': true };
            }
        }
    }

    static expiryDateIssueDateValidator(control) {
        if(control.value) {
           if ( new Date(control.value) > new Date(new Date().toDateString()) ) {
                return null;
            } else {
                return { 'invalidExpiryDate': true };
            }
        }
    }    
    
    //Check if formcontrol has been touched = invalid if not
    static untouchedValidator(control) { 
        if(control.pristine){
             return {'untouchedControl': true };
        } else{
            return null;
        }
    }

    //Check password controls are equal
    matchingPasswords(passVal, confirmPassVal) {
        if (passVal !== confirmPassVal) {
            console.log("They are not equal");
            return false;
          
        } else {
            console.log("They are equal");
             return true;
        }
    }

    // Check all fields are unique
    checkFieldsUnique(formControls): boolean{
        let inputs = [];
        let uniqueFields = true;

        Object.keys(formControls).forEach(key => {
            let value = formControls[key].value;

            if(inputs.indexOf(value) > -1 && value !== "") {
                uniqueFields = false;
            } else {
                inputs.push(value);
            }
        });
        
        return uniqueFields;
    }

    // Check all fields are not empty
    checkFieldsHaveValues(formControls): boolean{
        let fieldsEmpty = false;

        Object.keys(formControls).forEach(key => {
            let value = formControls[key].value;

            if(value == ""){
                fieldsEmpty = true
            } else {
                fieldsEmpty = false
            }
        });

        return fieldsEmpty;
    }

}




// WEBPACK FOOTER //
// ./src/shared/validation.service.ts